/* Cart v2 (A/B test)
   - Variant is active when <html> has the class "cc-cart-v2".
     ABlyft adds the class in the test variant; for internal previews
     ?preview_cart_v2=1 (and =0 to turn off) toggles it per browser tab.
   - Collapses the buyer-type widget (Privat-/Geschaeftskunde) into a
     dropdown while the variant is active. No-op otherwise. */
(function () {
  var CLS = 'cc-cart-v2';
  var html = document.documentElement;

  try {
    var m = window.location.search.match(/[?&]preview_cart_v2=(1|0)/);
    if (m) sessionStorage.setItem(CLS, m[1]);
    if (sessionStorage.getItem(CLS) === '1') html.classList.add(CLS);
  } catch (e) {
    /* storage unavailable: preview toggle simply not persisted */
  }

  var CARET =
    '<svg width="8" height="4" viewBox="0 0 8 4" fill="none" aria-hidden="true">' +
    '<path d="M4 4C3.84338 4.00025 3.68825 3.97203 3.54353 3.91697C3.39881 3.86191 3.26735 3.78108 3.1567 3.67914L0 0.775538L0.843298 0L4 2.90306L7.1567 0L8 0.775538L4.8433 3.67859C4.7327 3.78063 4.60126 3.86156 4.45654 3.91672C4.31181 3.97187 4.15666 4.00018 4 4Z" fill="currentColor"/></svg>';

  function initBuyerType() {
    if (!html.classList.contains(CLS)) return;

    var wrappers = document.querySelectorAll('.buyer-type-wrapper:not([data-cc-v2-init])');

    for (var i = 0; i < wrappers.length; i++) {
      (function (wrapper) {
        wrapper.setAttribute('data-cc-v2-init', '');

        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'cc-b2b-toggle';
        toggle.setAttribute('aria-expanded', 'false');

        function updateLabel() {
          var active = wrapper.querySelector('.buyer-btn.active');
          var label = active ? active.textContent.replace(/\s+/g, ' ').trim() : 'Privatkunde';
          toggle.innerHTML = '<span>' + label + '</span>' + CARET;
        }

        updateLabel();

        toggle.addEventListener('click', function () {
          var open = wrapper.classList.toggle('cc-open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });

        wrapper.addEventListener('click', function (e) {
          if (e.target && e.target.closest && e.target.closest('.buyer-btn')) {
            window.setTimeout(updateLabel, 0);
          }
        });

        wrapper.insertBefore(toggle, wrapper.firstChild);
      })(wrappers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuyerType);
  } else {
    initBuyerType();
  }

  /* Re-init after the drawer re-renders (cart updates replace its HTML)
     and when the variant class is added later (e.g. by ABlyft). */
  new MutationObserver(initBuyerType).observe(html, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();
